"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CarouselIndicator = function CarouselIndicator(_ref) {
  var selected = _ref.selected,
      onClick = _ref.onClick,
      color = _ref.color,
      props = _objectWithoutPropertiesLoose(_ref, ["selected", "onClick", "color"]);

  var Element = onClick ? 'button' : 'span';
  return (0, _themeUi.jsx)(Element, _extends({}, props, {
    onClick: onClick,
    sx: {
      position: 'relative',
      cursor: onClick ? 'pointer' : 'default',
      height: 1,
      width: 1,
      borderWidth: 'thin',
      borderStyle: 'solid',
      borderColor: color,
      borderRadius: 'medium'
    }
  }), (0, _themeUi.jsx)("span", {
    sx: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: selected ? 'translate(-50%, -50%) scale(1)' : 'translate(-50%, -50%) scale(0)',
      width: 'inherit',
      height: 'inherit',
      borderRadius: 'inherit',
      bg: color,
      transition: function transition(theme) {
        return "transform 150ms " + theme.easing.standard;
      }
    }
  }));
};

CarouselIndicator.propTypes = {
  onClick: _propTypes["default"].func,
  selected: _propTypes["default"].bool,
  color: _propTypes["default"].string
};
CarouselIndicator.defaultProps = {
  selected: false,
  color: 'primary'
};
var _default = CarouselIndicator;
exports["default"] = _default;